import createSvgIcon from '@icons/utils/create-svg-icon';
import BarChartSvg from './svg/bar-chart.svg';

const BarChartIcon = createSvgIcon(BarChartSvg);

export default BarChartIcon;
